import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoneAllIcon(props: IconProps) {
    return <Icon {...props} iconKey={"done_all"}/>
}
